export const en = {
    add: 'Select',
    cancel: 'Cancel',
    title: 'Creative «{creativeName}»'
};
